import React from 'react';
import EstheticReserveCompleteTemplate from '../../components_membership_hotel/template/esthetic/estheticReserveCompleteTemplate';
import { getReserveList } from '../../const';
import common from '../../resources/js/common/common';
class EstheticReserveComplete extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            reservationConfList: [],
            membershipReservationConfPopup: false,
            membershipReservationCancelPopup: false,
            loginFlg: false
        };
    };

    render() {

        // モーダルClose
        const onClickClosePopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // キャンセルモーダルClose
        const onClickCloseCancelPopupWindow = () => { this.setState({ membershipReservationCancelPopup: false }); };

        // 予約確認モーダル
        const onClickOpenReservationPopupWindow = (pointKaiinId) => {
            this.setState({ membershipReservationConfPopup: true });
            common.doPost(getReserveList, { pointKaiinId: pointKaiinId, importedFlg: true }, afterGetReserveList);
        }

        // 予約情報取得後処理
        const afterGetReserveList = (res) => {
            let data = res.data;
            if (data.resultCode == 0) {
                this.setState({ reservationConfList: res.data, });
            }
        }

        // 予約確認モーダルを閉じる
        const onClickCloseReservationConfPopupWindow = () => { this.setState({ membershipReservationConfPopup: false }); };

        // キャンセルモーダル
        const onClickOpenCancelPopupWindow = () => {
            this.setState({ membershipReservationCancelPopup: true });
        }

        // 予約確認ポップアップ表示制御用ログインフラグ設定
        const setLoginFlg = (loginFlg) => this.setState({ loginFlg: loginFlg });

        return (
            <div>
                <EstheticReserveCompleteTemplate
                    state={this.state}
                    onClickOpenReservationPopupWindow={onClickOpenReservationPopupWindow}
                    onClickCloseReservationConfPopupWindow={onClickCloseReservationConfPopupWindow}
                    onClickClosePopupWindow={onClickClosePopupWindow}
                    onClickOpenCancelPopupWindow={onClickOpenCancelPopupWindow}
                    onClickCloseCancelPopupWindow={onClickCloseCancelPopupWindow}
                    setLoginFlg={setLoginFlg}
                />
            </div>
        )
    }
}

export default EstheticReserveComplete;